import React from 'react';
import { Space, Popconfirm, Tag, Button } from 'antd';
import { EditOutlined, DeleteOutlined, ApartmentOutlined } from '@ant-design/icons';
import type { ColumnsType } from 'antd/es/table';
import type { Department, ModuleOption } from '../../../services/organizationAPI';

interface DepartmentTableColumnsProps {
    modules: ModuleOption[];
    onEdit: (dept: Department) => void;
    onDelete: (id: number) => void;
}

export const useDepartmentTableColumns = ({ modules, onEdit, onDelete }: DepartmentTableColumnsProps): ColumnsType<Department> => {
    return [
        {
            title: '部门名称',
            dataIndex: 'name',
            key: 'name',
            render: (text) => (
                <Space>
                    <ApartmentOutlined />
                    {text}
                </Space>
            ),
        },
        {
            title: '描述',
            dataIndex: 'description',
            key: 'description',
            ellipsis: true,
        },
        {
            title: '权限模块',
            dataIndex: 'permissions',
            key: 'permissions',
            render: (perms: string[]) => (
                <Space wrap>
                    {!Array.isArray(perms) || perms.length === 0 ? (
                        <Tag color="green">全部权限</Tag>
                    ) : (
                        perms.map((p) => {
                            const mod = modules.find((m) => m.key === p);
                            return <Tag key={p}>{mod?.name || p}</Tag>;
                        })
                    )}
                </Space>
            ),
        },
        {
            title: '成员数',
            dataIndex: 'member_count',
            key: 'member_count',
            width: 80,
        },
        {
            title: '操作',
            key: 'action',
            width: 120,
            render: (_, record) => (
                <Space>
                    <Button
                        type="link"
                        size="small"
                        icon={<EditOutlined />}
                        onClick={() => onEdit(record)}
                    />
                    <Popconfirm
                        title="确定删除该部门？"
                        onConfirm={() => onDelete(record.id)}
                    >
                        <Button type="link" size="small" danger icon={<DeleteOutlined />} />
                    </Popconfirm>
                </Space>
            ),
        },
    ];
};
